import { render, staticRenderFns } from "./PaintingRoom.vue?vue&type=template&id=d5d4ffd0&scoped=true&"
import script from "./PaintingRoom.vue?vue&type=script&lang=js&"
export * from "./PaintingRoom.vue?vue&type=script&lang=js&"
import style0 from "./PaintingRoom.vue?vue&type=style&index=0&id=d5d4ffd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d4ffd0",
  null
  
)

export default component.exports